import { FramebufferTexture, PixelFormat, pixelFormatValues } from '../../thirdparty/three/imports';
import { Texture3D } from './Texture3D';

export class FramebufferTexture3D extends Texture3D
{
    constructor(width: number, height: number, format: PixelFormat)
    {
        super();
        this._texture = new FramebufferTexture(width, height, pixelFormatValues[format]);
    }
}
